<template>
  <div class="min-h-screen flex flex-col bg-gray-50">
    <AppHeader />
    
    <main class="flex-1 pt-16">
      <div class="container mx-auto px-4 pt-4 max-w-6xl">
        <Breadcrumbs />
      </div>
      <RouterView />
    </main>
    
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import Breadcrumbs from '@/components/common/Breadcrumbs.vue'
</script>
